module.exports = __webpack_public_path__ + "static/media/Ben_Manley_Portrait.f869daec.jpg";